export default __webpack_public_path__ + "static/media/doc-check-tool.780f502e.jpg";